// import React, { useEffect, useState } from "react";
// import { Container, Row, Col } from "reactstrap";
// import { jwtDecode } from "jwt-decode"; // Corrected named import

// import Highlight from "../components/Highlight"; // Assuming this is the correct path
// import Loading from "../components/Loading";
// import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

// export const ProfileComponent = () => {
//   const { user, getAccessTokenSilently } = useAuth0();
//   const [accessToken, setAccessToken] = useState("");
//   const [decodedToken, setDecodedToken] = useState(null);

//   useEffect(() => {
//     const fetchAccessToken = async () => {
//       try {
//         const token = await getAccessTokenSilently();
//         setAccessToken(token);
//         const decoded = jwtDecode(token); // Using the correct function
//         setDecodedToken(decoded);
//       } catch (error) {
//         console.error("Error fetching access token:", error);
//       }
//     };

//     fetchAccessToken();
//   }, [getAccessTokenSilently]);

//   return (
//     <Container className="mb-5">
//       <Row className="align-items-center profile-header mb-5 text-center text-md-left">
//         <Col md={2}>
//           <img
//             src={user.picture}
//             alt="Profile"
//             className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
//           />
//         </Col>
//         <Col md>
//           <h2>{user.name}</h2>
//           <p className="lead text-muted">{user.email}</p>
//         </Col>
//       </Row>
//       <Row>
//         <h4>ID Token</h4>
//         <Highlight language="json">{JSON.stringify(user, null, 2)}</Highlight>
//       </Row>
     
//       <Row className="mt-3">
//         <Col>
//           <h4>Access Token</h4>
//           {decodedToken ? (
//             <Highlight language="json">{JSON.stringify(decodedToken, null, 2)}</Highlight>
//           ) : (
//             <p>Loading token claims...</p>
//           )}
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default withAuthenticationRequired(ProfileComponent, {
//   onRedirecting: () => <Loading />,
// });

import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { jwtDecode } from "jwt-decode";
import Highlight from "../components/Highlight";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdb-react-ui-kit";
import { Button } from "reactstrap";
import { Link } from 'react-router-dom';

export const ProfileComponent = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [accessToken, setAccessToken] = useState("");
  const [decodedToken, setDecodedToken] = useState(null);
  const [orgs, setOrgs] = useState([]); // Array to store organizations
  const [selectedOrg, setSelectedOrg] = useState(""); // State for selected organization

  useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        setAccessToken(token);
        const decoded = jwtDecode(token);
        setDecodedToken(decoded);
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    };

    fetchAccessToken();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    // Access the orgs claim directly from the user object
    const orgsClaim = user["company"]; // Adjust to match your namespace
    console.log("User data:", user);

    if (orgsClaim) {
      setOrgs(orgsClaim); // Set the orgs array from the user object
      setSelectedOrg(orgsClaim[0]); // Default to the first organization
    } else {
      console.warn("Orgs data is missing in the user object.");
    }
  }, [user]);

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
      {/* <Button
        id="qsLoginBtn"
        color="primary"
        className="btn-margin btn-pad"
        style={{ width: '200px' }} // Set the desired width here
      >
        <a
          href="http://localhost:3002/profile"
          target="_blank"
          rel="noopener noreferrer" // Prevent security vulnerabilities
          style={{ textDecoration: 'none', color: 'inherit', display: 'block', textAlign: 'center' }}
        >
          Route Mobile
        </a>
    </Button> */}
        <Col md={2}>
          <img
            src={user?.picture}
            alt="Profile"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
          />
        </Col>
        <Col md>
          <h2>{user.name}</h2>
          <p className="lead text-muted">{user.email}</p>
        </Col>
      </Row>

      {/* Dropdown with dynamic organization list */}
      {orgs.length > 0 && (
        <Row className="mt-3">
          <Col>
            <h4>Organization Hierarchy</h4>
            <MDBDropdown>
              <MDBDropdownToggle color="primary">
                {selectedOrg || "Select an Organization"}
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                {orgs.map((org, index) => (
                  <MDBDropdownItem
                    key={index}
                    onClick={() => setSelectedOrg(org)}
                  >
                    {org}
                  </MDBDropdownItem>
                ))}
              </MDBDropdownMenu>
            </MDBDropdown>
          </Col>
        </Row>
      )}
      
      <Row className="mt-4">
        <h4>ID Token</h4>
        <Highlight language="json">{JSON.stringify(user, null, 2)}</Highlight>
      </Row>

      <Row className="mt-3">
        <Col>
          <h4>Access Token</h4>
          {decodedToken ? (
            <Highlight language="json">{JSON.stringify(decodedToken, null, 2)}</Highlight>
          ) : (
            <p>Loading token claims...</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
